var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { id: "id-29a", d: "M0 0h40v40H0z" }),
      React.createElement("path", { id: "id-32d", d: "M12.828.172l30.578.364 12.828 12.828L0 13z" }),
      React.createElement(
        "filter",
        { id: "id-31c", width: "123.1%", height: "198.5%", x: "-13.3%", y: "-41.7%", filterUnits: "objectBoundingBox" },
        React.createElement("feOffset", { dx: "-1", dy: "1", "in": "SourceAlpha", result: "shadowOffsetOuter1" }),
        React.createElement("feGaussianBlur", { "in": "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "2" }),
        React.createElement("feColorMatrix", { "in": "shadowBlurOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" })
      )
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "id-30b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#id-29a" })
      ),
      React.createElement(
        "g",
        { mask: "url(#id-30b)" },
        React.createElement(
          "g",
          { transform: "rotate(45 21.086 9.207)" },
          React.createElement("use", { fill: "#000", filter: "url(#id-31c)", xlinkHref: "#id-32d" }),
          React.createElement("use", { fill: "#ED9700", xlinkHref: "#id-32d" }),
          React.createElement("use", { fill: "#018489", xlinkHref: "#id-32d" })
        ),
        React.createElement(
          "text",
          { fontFamily: "HelveticaNeue-Bold, Helvetica Neue", fontSize: "10", fontWeight: "bold", letterSpacing: ".25", transform: "rotate(45 21.086 9.207)" },
          React.createElement(
            "tspan",
            { x: "15.218", y: "10.293", fill: "#FFF" },
            "BETA"
          )
        )
      )
    )
  );
});